import { render, staticRenderFns } from "./BSUploadUrenModal.vue?vue&type=template&id=fe9864ac"
import script from "./BSUploadUrenModal.vue?vue&type=script&lang=js"
export * from "./BSUploadUrenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports